export const environment = {
  production: false,
  baseUrl: 'https://api-testing.incentify.cloud/api',
  googleMapsApiKey: 'AIzaSyCPwiosj3mkzfiH4JrsTTaiXbJ4wC0Ke5g',
};
